// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M-j2","col":"styles_col__nOgZd"};